import { mantineColorRamps } from "~/ui";

export const GREEN_PALETTE = mantineColorRamps.green;
export const BLUE_PALETTE = mantineColorRamps.blue;
export const INDIGO_PALETTE = mantineColorRamps.indigo;
export const ACTION_ACCENT = "#1B3D78";
export const GRAY_PALETTE = mantineColorRamps.gray;
export const DANGER_PALETTE = mantineColorRamps.danger;
export const RED_PALLETTE = mantineColorRamps.red;
export const YELLOW_PALETTE = mantineColorRamps.yellow;
export const ORANGE_PALETTE = mantineColorRamps.orange;
export const BROWN_PALETTE = mantineColorRamps.brown;
export const VIOLET_PALETTE = mantineColorRamps.violet;
export const LIME_PALETTE = mantineColorRamps.lime;
export const TEAL_PALETTE = mantineColorRamps.teal;
export const CYAN_PALETTE = mantineColorRamps.cyan;
export const GRAPE_PALETTE = mantineColorRamps.grape;
export const PINK_PALETTE = mantineColorRamps.pink;
export const HEADING_PALETTE = mantineColorRamps.heading;
export const BODY_PALETTE = mantineColorRamps.body;
